import React from "react";
import PropTypes from "prop-types";
import { EXTENSION_PAGE } from "../../../../shared/extension-preview.js";
import useExtensionSurfacePreviewState from "./useExtensionSurfacePreviewState";
import ExtensionUpsellWidget from "./ExtensionUpsellWidget";
import PostPurchaseUpsellPopup from "../post-purchase/PostPurchaseUpsellPopup";
import styles from "./widget-only-extension-preview.module.css";

/**
 * Essential-style preview: only the upsell widget on a neutral canvas.
 * No checkout / thank-you / order-status / post-purchase page mock.
 * Desktop vs mobile canvas width follows the editor toolbar for all 4 surfaces.
 *
 * @param {boolean} [fitContent] — list layout uses height: max-content;
 *   slider (and other) layouts use height: 100vh.
 */
export default function WidgetOnlyExtensionPreview({
  surface,
  popupData,
  popupState,
  setPopupState,
  fitContent = false,
}) {
  const preview = useExtensionSurfacePreviewState({
    popupData,
    popupState,
    setPopupState,
  });

  const isPostPurchase = surface === EXTENSION_PAGE.POST_PURCHASE;

  return (
    <div
      className={`${styles.root} ${fitContent ? styles.rootFitContent : ""} ${
        preview.isMobile ? styles.mobile : ""
      }`.trim()}
      data-testid="widget-only-extension-preview"
      data-extension-surface={surface || ""}
      data-preview-chrome="widget"
      data-preview-device={preview.isMobile ? "mobile" : "desktop"}
      data-preview-height={fitContent ? "max-content" : "100vh"}
    >
      <div className={styles.canvas}>
        {isPostPurchase ? (
          <PostPurchaseUpsellPopup
            popupData={popupData}
            popupState={popupState}
            setPopupState={setPopupState}
            chrome="widget"
          />
        ) : (
          <ExtensionUpsellWidget
            surfaceBadge={null}
            mapped={preview.mapped}
            popupData={popupData}
            activeStep={preview.activeStep}
            currentParentData={preview.currentParentData}
            selectedBlock={preview.selectedBlock}
            handleBlockClick={preview.handleBlockClick}
            isSelected={preview.isSelected}
            renderCta={preview.renderCta}
          />
        )}
      </div>
    </div>
  );
}

WidgetOnlyExtensionPreview.propTypes = {
  surface: PropTypes.string,
  popupData: PropTypes.object,
  popupState: PropTypes.object,
  setPopupState: PropTypes.func,
  fitContent: PropTypes.bool,
};
